import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_IconFolder = _resolveComponent("IconFolder")
  const _component_IconPoll = _resolveComponent("IconPoll")
  const _component_IconForumOutline = _resolveComponent("IconForumOutline")
  const _component_NcActions = _resolveComponent("NcActions")

  return (_openBlock(), _createBlock(_component_NcActions, {
    ref: "attachmentsMenu",
    disabled: $props.disabled,
    "force-menu": true,
    "aria-label": $options.t('spreed', 'Share files to the conversation'),
    "aria-haspopup": true
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_IconPlus, { size: 20 })
    ]),
    default: _withCtx(() => [
      ($props.canUploadFiles)
        ? (_openBlock(), _createBlock(_component_NcActionButton, {
            key: 0,
            "close-after-click": "",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('openFileUpload')))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_NcIconSvgWrapper, {
                svg: $setup.IconFileUpload,
                size: 20
              }, null, 8, ["svg"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Upload from device')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($props.canShareFiles)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_NcActionButton, {
              "close-after-click": "",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('handleFileShare')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconFolder, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString($options.shareFromNextcloudLabel), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fileTemplateOptions, (provider, index) => {
              return (_openBlock(), _createBlock(_component_NcActionButton, {
                key: index,
                "close-after-click": "",
                icon: provider.iconClass,
                onClick: $event => (_ctx.$emit('updateNewFileDialog', index))
              }, _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(provider.label), 1)
                ]),
                _: 2
              }, [
                (provider.iconSvgInline)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        _createVNode(_component_NcIconSvgWrapper, {
                          svg: provider.iconSvgInline,
                          size: 20
                        }, null, 8, ["svg"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["icon", "onClick"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      ($props.canCreatePoll)
        ? (_openBlock(), _createBlock(_component_NcActionButton, {
            key: 2,
            "close-after-click": "",
            onClick: $options.showPollEditor
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconPoll, { size: 20 })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Create new poll')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      ($props.canCreateThread)
        ? (_openBlock(), _createBlock(_component_NcActionButton, {
            key: 3,
            "close-after-click": "",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('createThread', true)))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconForumOutline, { size: 20 })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Create a thread')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_NcActionButton, {
        "close-after-click": "",
        onClick: $options.showSmartPicker
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_NcIconSvgWrapper, {
            svg: $setup.IconSmartPicker,
            size: 20
          }, null, 8, ["svg"])
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Smart picker')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["disabled", "aria-label"]))
}